module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargador-di-22f4cec1.png";